export interface LocalizationItemParams {
  ContentId?: string;
  IsClickToCall?: boolean;
  LanguageCode?: string;
  CountryName?: string;
  IsLocalSales?: string;
}

export enum LocalizationType {
  Simple = 'Simple',
  Predefined = 'Predefined',
  Phone = 'Phone'
}

export default interface LocalizationItem {
  Id: string;
  Type?: LocalizationType;
  Params?: LocalizationItemParams;
}
